export default {
    INIT: 'INIT',
    SET_COMPANY: 'SET_COMPANY',
    EDIT_COMPANY_PROP: 'EDIT_COMPANY_PROP',
    EDIT_SUB_PROP: 'EDIT_SUB_PROP',
    EDIT_ADDRESS: 'EDIT_ADDRESS',
    CHANGE_VALIDATION: 'CHANGE_VALIDATION',
    UPDATE_COMPANY: 'UPDATE_COMPANY',
};
